module.exports = __webpack_public_path__ + "img/shield.6e3d15d7.svg";